module.exports = __webpack_public_path__ + "static/media/user-avatar.480456bf.svg";